import {
  ref,
  getStorage,
  uploadBytes,
  deleteObject,
  getDownloadURL,
} from 'firebase/storage';

interface Upload {
  path: string;
  file: File;
}

interface UploadFirebaseImage {
  path: string;
  file: File;
  thumbnail: File;
}

export const uploadFileToStorage = (props: Upload) => {
  const storage = getStorage();
  const storageRef = ref(storage, props.path);
  return uploadBytes(storageRef, props.file);
};

export const uploadFile = async (props: Upload) => {
  try {
    const result = await uploadFileToStorage(props);
    const url = await getDownloadURL(result.ref);

    return Promise.resolve(url);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const uploadFirebaseImage = async (props: UploadFirebaseImage) => {
  try {
    const originalPath = `${props.path}/original`;
    const thumbnailPath = `${props.path}/thumbnail`;

    const paths = [originalPath, thumbnailPath];
    const files = [props.file, props.thumbnail];

    const result = await Promise.all(
      paths.map((item, index) => uploadFile({ path: item, file: files[index] }))
    );

    return Promise.resolve({ originalURI: result[0], thumbnailURI: result[1] });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const uploadFirebaseImages = async (images: UploadFirebaseImage[]) => {
  return Promise.all(images.map((props) => uploadFirebaseImage(props)));
};

export const deleteFile = ({ path }: Omit<Upload, 'file'>) => {
  const storage = getStorage();
  const fileRef = ref(storage, path);
  return deleteObject(fileRef);
};
